import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/shape.png'


const _hoisted_1 = { class: "card bg-card-bg-c bg-primary border-0 rounded-3 mb-4 overflow-hidden position-relative" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "d-flex align-items-center py-3" }
const _hoisted_4 = { class: "flex-shrink-0" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex-grow-1 ms-3" }
const _hoisted_7 = { class: "d-block mb-2 text-white" }
const _hoisted_8 = { class: "mb-0 fs-20 text-white" }
const _hoisted_9 = { class: "mb-2 fs-20 text-white" }
const _hoisted_10 = { class: "ps-0 mb-3 list-unstyled d-flex flex-wrap gap-2 gap-sm-0 list-dot" }
const _hoisted_11 = { class: "text-white" }
const _hoisted_12 = { class: "text-white" }
const _hoisted_13 = { class: "text-white" }
const _hoisted_14 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createBlock(_component_Swiper, {
    slidesPerView: 1,
    spaceBetween: 24,
    centeredSlides: true,
    preventClicks: true,
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: '.swiper-pagination2',
      clickable: true,
    },
    modules: _ctx.modules,
    class: "courses-slide"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(_component_SwiperSlide, {
          key: item.id
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "mb-0 text-card-text-c fw-semibold" }, "Our Top Courses", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      src: item.image,
                      class: "wh-130-113 rounded-3",
                      alt: "courses"
                    }, null, 8, _hoisted_5)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(item.title), 1),
                    _createElementVNode("h3", _hoisted_8, "$" + _toDisplayString(item.price), 1)
                  ])
                ]),
                _createElementVNode("h3", _hoisted_9, _toDisplayString(item.infoTitle), 1),
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", _hoisted_11, _toDisplayString(item.sections) + " sections", 1),
                  _createElementVNode("li", _hoisted_12, _toDisplayString(item.lectures) + " lectures", 1),
                  _createElementVNode("li", _hoisted_13, _toDisplayString(item.time), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_RouterLink, {
                    to: "/lms/course-details",
                    class: "btn border-color-white text-white py-1 px-2 px-sm-4 fs-14 fw-medium rounded-3 hover-bg"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createElementVNode("span", { class: "py-sm-1 d-block" }, [
                        _createElementVNode("i", { class: "ri-add-line me-1" }),
                        _createElementVNode("span", null, "View Details")
                      ], -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _cache[2] || (_cache[2] = _createElementVNode("img", {
                src: _imports_0,
                class: "position-absolute top-0 end-0",
                alt: "shape"
              }, null, -1))
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "swiper-pagination2 text-center" }, null, -1))
    ]),
    _: 1
  }, 8, ["modules"]))
}